export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/state.js